import { User as BaseUser } from 'alto-react-base-auth/lib/models'

export default class User extends BaseUser
  @onlyAttrs: BaseUser.onlyAttrs.concat(['client'])
